export const PATHS = {
  path: '/:locale(no|en|uk)',
  part: 'unset',
  AccessDenied: {
    path: '/:locale(no|en|uk)/access-denied',
    part: 'access-denied',
  },
};
